import { httpClientPrivate } from '@/libs/httpClient'
import { CrashDetectionDashboardResponse } from '../types'
import config from '@/config'
import { useQuery } from '@tanstack/react-query'

const fetchCrashDetectionDashboardList = async (params: {
  search?: string
  page: number
  limit: number
  sortBy?: string
  filter?: string
}) => {
  const search = params.search ? `search=${params.search}&` : ''
  const sortBy = params.sortBy ? `&sortBy=${params.sortBy}` : ''
  const filter = params.filter ? `&${params.filter}` : ''

  const { data } = await httpClientPrivate.get<CrashDetectionDashboardResponse>(
    `${config.restUrl}/v1/backoffice/crash-detection/dashboard?${search}page=${params.page}&limit=${params.limit}${sortBy}${filter}`,
  )

  return data
}

const useCrashDetectionDashboardList = (params: {
  search?: string
  page: number
  limit: number
  sortBy?: string
  filter?: string
  enabled?: boolean
  refetchInterval?: number | false
}) => {
  const queryKey = ['useCrashDetectionDashboardList', params]
  const queryFn = async () => fetchCrashDetectionDashboardList(params)
  const queryResult = useQuery({
    queryKey,
    queryFn,
    enabled: params.enabled !== false,
    refetchInterval: params.refetchInterval,
  })

  return { ...queryResult }
}

export { fetchCrashDetectionDashboardList, useCrashDetectionDashboardList }
